import {Component} from 'react';
import PropTypes from 'prop-types';
import React from 'react';
import {
  Button
} from '@sketchpixy/rubix';
import styled from 'styled-components';


const StyledButton = styled(Button)`
  background-color: #f68b1f;
  border-color: #f68b1f;
  display: flex;
  align-content: center;
  justify-content: center;

  &:disabled {
    background-color: #f68b1f99;
    cursor: not-allowed;
  }
`;

const Spinner = styled.span`
  @keyframes spinner {
    to {transform: rotate(360deg);}
  }

  display: ${props => props.isLoading ? 'inline-block' : 'none'};
  width: 20px;
  height: 20px;
  margin: auto 20px auto 0;
  border-radius: 50%;
  border: 2px solid #f68b1f;
  border-right-color: transparent;
  animation: spinner .6s linear infinite;
`;

class PayButton extends Component {
  render() {
    return <StyledButton
        size="large"
        block
        style={{fontWeight: 'bold'}}
        onClick={this.props.onClick}
        disabled={this.props.disabledButton || this.props.loading}
    >
      <Spinner isLoading={this.props.loading} />
      <span>
        {
          this.props.buttonName ? (
              this.props.buttonName
          ) : 'Save'
        }
      </span>
    </StyledButton>;
  }
}

PayButton.propTypes = {
  onClick: PropTypes.func,
  disabledButton: PropTypes.bool,
  loading: PropTypes.bool,
  buttonName: PropTypes.string,
};

export default PayButton;



// WEBPACK FOOTER //
// ./src/routes/patient/Modal/EditCard/PayButton.js